export const AWS_MAX_DURATION = 7200000; // 2 hours, defined by AWS, not customizable
export const KEEP_ALIVE_INTERVAL = 540000; // 9min, because AWS idle every 10 minutes and close the connection
